<template>
  <CRow class="justify-content-center">
    <Modal :modal="modal"></Modal>

    <!-- Content -->
    <CCol col="12">
      <CForm @submit.prevent="send">
        <div class="d-flex align-items-center justify-content-end mb-3">
          <a
            href="javascript:void(0)"
            @click="$router.go(-1)"
          >
            <CIcon
              name="cil-arrow-left"
              class="mr-2"
            />Voltar
          </a>
        </div>

        <!-- Title -->
        <CCard>
          <CCardHeader>
            <div class="d-flex justify-content-between align-items-center">
              <h4 class="mb-0">
                {{ $route.params.id ? 'Editar Publicação' : 'Cadastrar Publicação' }}
              </h4>

              <div class="d-flex align-items-center">
                <div class="ml-2 d-flex align-items-center">
                  <!-- Status -->
                  <label class="mb-0">
                    <b>Status</b>
                  </label>
                  <CSwitch
                    type="checkbox"
                    color="success"
                    variant="3d"
                    class="mx-2"
                    v-bind="labelIcon"
                    :checked.sync="form.status"
                  />
                </div>
              </div>
            </div>
          </CCardHeader>
        </CCard>

        <!-- Content -->
        <CCard>
          <CCardBody>
            <CTabs
              :active-tab="activeTabIndex"
              :vertical="vertical"
              :variant="variant"
              add-nav-wrapper-classes="website-tabs"
              add-tabs-wrapper-classes="website-tabs"
              class="ml-1"
              @update:activeTab="handleActiveTab"
            >
              <!-- BR -->
              <CTab>
                <!-- Tab title -->
                <template
                  slot="title"
                >
                  <div class="d-flex align-items-center">
                    <img
                      :src="require(`@/assets/img/flags/pt-br.svg`)"
                      alt="Bandeira Inglesa"
                      class="flag mr-2"
                    />
                    Português
                    <TabsStatus :exibition="form.status" />
                  </div>
                </template>

                <!-- Fields -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    Informações
                  </h5>
                </div>

                <CRow>
                  <CCol lg="12">
                    <CRow>
                      <!-- Section -->
                      <CCol lg="6">
                        <div class="form-group">
                          <label for="">Seção*</label>

                          <Multiselect
                            :value="sectionsOptions.find(option => option.value == form.section_id)"
                            :options="sectionsOptions"
                            label="label"
                            track-by="value"
                            :disabled="processing"
                            @select="(selected) => {
                              form.section_id = selected.value,
                              form.section_slug = selected.slug,
                              form.section_slug_en = selected.slug_en,
                              form.section_slug_es = selected.slug_es
                            }"
                          />
                        </div>
                      </CCol>

                      <!-- Title -->
                      <CCol lg="6">
                        <CInput
                          id="first"
                          v-model="form.title"
                          label="Título*"
                          :disabled="processing"
                        />
                      </CCol>
                    </CRow>
                  </CCol>
                </CRow>

                <CRow>
                  <CCol lg="12">
                    <div class="form-group">
                      <label for="mission">Descrição*</label>

                      <TextEditor
                        id="mission"
                        v-model="form.description"
                        :disabled="processing"
                      />
                    </div>
                  </CCol>
                </CRow>

                <!-- PRODUCTS -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    Produtos Relacionados
                  </h5>
                </div>

                <CRow>
                  <CCol lg="12">
                    <CRow>
                      <!-- Section -->
                      <CCol lg="6">
                        <div class="form-group">
                          <label for="">Produtos*</label>

                          <Multiselect
                            id=""
                            :value="productsOptions.filter((option) => form.related.includes(option.value))"
                            :options="productsOptions"
                            :searchable="true"
                            label="label"
                            track-by="value"
                            :multiple="true"
                            :limit="1"
                            :limit-text="count => `e ${count} mais`"
                            @select="(selected) => form.related.push(selected.value)"
                            @remove=" (removed) => form.related.splice(form.related.indexOf(removed.value),1)"
                          >
                            <span slot="noResult">Nenhum resultado encontrado</span>
                          </Multiselect>
                        </div>
                      </CCol>
                    </CRow>
                  </CCol>
                </CRow>

                <!-- SEO -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    SEO
                  </h5>
                </div>

                <CRow>
                  <CCol
                    lg="12"
                  >
                    <FriendlyUrl
                      :value="form.slug"
                      :based-on="form.title"
                      :disabled="processing"
                      :entity="$route.params.id"
                      field="slug"
                      model="publications"
                      @change="(value) => form.slug = value"
                    />
                  </CCol>
                </CRow>

                <Seo
                  :form="form.seo"
                  :page-title="form.title"
                  :page-description="form.description"
                  :is-edit="!!$route.params.id"
                />
              </CTab>

              <!-- EN -->
              <CTab>
                <!-- Tab title -->
                <template
                  slot="title"
                >
                  <div class="d-flex align-items-center">
                    <img
                      :src="require(`@/assets/img/flags/en.svg`)"
                      alt="Bandeira Inglesa"
                      class="flag mr-2"
                    />
                    Inglês
                    <TabsStatus :exibition="form.status_en && form.status" />
                  </div>
                </template>

                <!-- Title -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    Informações
                  </h5>

                  <div class="d-flex align-items-center">
                    <div class="ml-2 d-flex align-items-center">
                      <label class="mb-0">
                        <b>Exibir</b>
                      </label>

                      <CSwitch
                        type="checkbox"
                        color="success"
                        variant="3d"
                        class="mx-2"
                        v-bind="labelIcon"
                        :checked.sync="form.status_en"
                      />
                    </div>
                  </div>
                </div>

                <!-- Fields -->
                <CRow>
                  <CCol col="12">
                    <CInput
                      v-model="form.title_en"
                      :label="`Título*`"
                      :disabled="processing"
                    />
                  </CCol>

                  <CCol col="12">
                    <div class="form-group">
                      <label for="description">Descrição*</label>

                      <TextEditor
                        id="english-description"
                        v-model="form.description_en"
                        :disabled="processing"
                      />
                    </div>
                  </CCol>
                </CRow>

                <!-- PRODUCTS -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    Produtos Relacionados
                  </h5>
                </div>

                <CRow>
                  <CCol lg="12">
                    <CRow>
                      <!-- Section -->
                      <CCol lg="6">
                        <div class="form-group">
                          <label for="">Produtos*</label>

                          <Multiselect
                            id=""
                            :value="productsOptionsEn.filter((option) => form.related_en.includes(option.value))"
                            :options="productsOptionsEn"
                            :searchable="true"
                            label="label"
                            track-by="value"
                            :multiple="true"
                            :limit="1"
                            :limit-text="count => `e ${count} mais`"
                            @select="(selected) => form.related_en.push(selected.value)"
                            @remove=" (removed) => form.related_en.splice(form.related_en.indexOf(removed.value),1)"
                          >
                            <span slot="noResult">Nenhum resultado encontrado</span>
                          </Multiselect>
                        </div>
                      </CCol>
                    </CRow>
                  </CCol>
                </CRow>

                <!-- SEO -->
                <CRow>
                  <CCol lg="12">
                    <div class="subtitle">
                      <h5>
                        <CIcon
                          name="cil-justify-center"
                        />
                        SEO
                      </h5>
                    </div>
                  </CCol>

                  <CCol
                    lg="12"
                  >
                    <FriendlyUrl
                      :value="form.slug_en"
                      :based-on="form.title_en"
                      :disabled="processing"
                      :entity="$route.params.id"
                      field="slug_en"
                      model="publications"
                      @change="(value) => form.slug_en = value"
                    />
                  </CCol>
                </CRow>

                <Seo
                  :form="form.seo_en"
                  :page-title="form.title_en"
                  :page-description="form.description_en"
                  :is-edit="!!$route.params.id"
                />
              </CTab>

              <!-- ES -->
              <CTab>
                <!-- Tab title -->
                <template slot="title">
                  <div class="d-flex align-items-center">
                    <img
                      :src="require(`@/assets/img/flags/es.svg`)"
                      alt="Bandeira Espanhola"
                      class="flag mr-2"
                    />
                    Espanhol
                    <TabsStatus :exibition="form.status_es && form.status" />
                  </div>
                </template>

                <!-- Title -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    Informações
                  </h5>

                  <div class="d-flex align-items-center">
                    <div class="ml-2 d-flex align-items-center">
                      <label class="mb-0">
                        <b>Exibir</b>
                      </label>

                      <CSwitch
                        type="checkbox"
                        color="success"
                        variant="3d"
                        class="mx-2"
                        v-bind="labelIcon"
                        :checked.sync="form.status_es"
                      />
                    </div>
                  </div>
                </div>

                <!-- Fields -->
                <CRow>
                  <CCol col="12">
                    <CInput
                      v-model="form.title_es"
                      :label="`Título*`"
                      :disabled="processing"
                    />
                  </CCol>

                  <CCol col="12">
                    <div class="form-group">
                      <label for="spanish-description">Descrição*</label>

                      <TextEditor
                        id="spanish-description"
                        v-model="form.description_es"
                        :disabled="processing"
                      />
                    </div>
                  </CCol>
                </CRow>

                <!-- PRODUCTS -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    Produtos Relacionados
                  </h5>
                </div>

                <CRow>
                  <CCol lg="12">
                    <CRow>
                      <!-- Section -->
                      <CCol lg="6">
                        <div class="form-group">
                          <label for="">Produtos*</label>

                          <Multiselect
                            id=""
                            :value="productsOptionsEs.filter((option) => form.related_es.includes(option.value))"
                            :options="productsOptionsEs"
                            :searchable="true"
                            label="label"
                            track-by="value"
                            :multiple="true"
                            :limit="1"
                            :limit-text="count => `e ${count} mais`"
                            @select="(selected) => form.related_es.push(selected.value)"
                            @remove=" (removed) => form.related_es.splice(form.related_es.indexOf(removed.value),1)"
                          >
                            <span slot="noResult">Nenhum resultado encontrado</span>
                          </Multiselect>
                        </div>
                      </CCol>
                    </CRow>
                  </CCol>
                </CRow>

                <!-- SEO -->
                <CRow>
                  <CCol lg="12">
                    <div class="subtitle">
                      <h5>
                        <CIcon
                          name="cil-justify-center"
                        />
                        SEO
                      </h5>
                    </div>
                  </CCol>

                  <CCol
                    lg="12"
                  >
                    <FriendlyUrl
                      :value="form.slug_es"
                      :based-on="form.title_es"
                      :disabled="processing"
                      :entity="$route.params.id"
                      field="slug_es"
                      model="publications"
                      @change="(value) => form.slug_es = value"
                    />
                  </CCol>
                </CRow>

                <Seo
                  :form="form.seo_es"
                  :page-title="form.title_es"
                  :page-description="form.description_es"
                  :is-edit="!!$route.params.id"
                />
              </CTab>
            </CTabs>
          </CCardBody>
        </CCard>

        <!-- Logs -->
        <CRow v-if="$route.params.id">
          <CCol sm="12">
            <CardLog :log="log" />
          </CCol>
        </CRow>

        <!-- Actions -->
        <div class="form-actions">
          <a
            v-if="$route.params.id"
            href="javascript:void(0)"
            class="mr-3"
            @click="resetForm"
          >Limpar Alterações</a>
          <CInputCheckbox
            v-else
            label="Criar outro"
            class="mr-3"
            :disabled="processing"
            @update:checked="setRedirect"
          />
          <CButton
            color="success"
            type="submit"
            :disabled="processing"
          >
            {{ processing ? 'Salvando...' : 'Salvar' }}
          </CButton>
        </div>
      </CForm>
    </CCol>
  </CRow>
</template>

<script>
// Components
import Modal from '@/components/ui/Modal'
import Multiselect from '@/components/ui/Multiselect'
import Seo from '@/components/ui/Seo'
import TabsStatus from '@/components/ui/TabsStatus'
import TextEditor from '@/components/ui/TextEditor'
import CardLog from '@/components/ui/CardLog'
import FriendlyUrl from '@/components/ui/FriendlyUrl'

import moment from 'moment'
import { cloneDeep } from 'lodash'

// Services
import Service from '@/services/publication.service'
import ChapterService from '@/services/chapter.service'
import ProductService from '@/services/products.service'

export default {
  metaInfo: {
    title: 'Publicações',
    titleTemplate: ' %s - Manager - Intelli'
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.$store.state.auth.permissions.includes('manage_publications')) {
        vm.$router.push('/404')
      }
    })
  },

  components: {
    Modal,
    Multiselect,
    Seo,
    TabsStatus,
    TextEditor,
    CardLog,
    FriendlyUrl
  },

  data() {
    return {
      vertical: false,
      variant: 'tabs',
      labelIcon: {
        labelOn: '\u2713',
        labelOff: '\u2715'
      },
      item: {
        section_id: '',
        section_slug: '',
        section_slug_en: '',
        section_slug_es: '',
        title: '',
        title_en: '',
        title_es: '',
        views: '',
        slug: '',
        slug_en: '',
        slug_es: '',
        description: '',
        description_en: '',
        description_es: '',
        related: [],
        related_en: [],
        related_es: [],
        status: true,
        status_en: false,
        status_es: false,
        seo: {
          seo_title: '',
          seo_description: ''
        },
        seo_en: {
          seo_title: '',
          seo_description: ''
        },
        seo_es: {
          seo_title: '',
          seo_description: ''
        }
      },
      form: {
        sections: [],
        related: [],
        related_en: [],
        related_es: []
      },
      sectionsOptions: [],
      productsOptions: [],
      productsOptionsEn: [],
      productsOptionsEs: [],
      seo: {},
      englishSeo: {},
      spanishSeo: {},
      log: {
        created_by: '',
        created_at: '',
        updated_by: '',
        updated_at: ''
      },
      processing: false,
      new: true,
      query: {
        sorter: {}
      },
      modal: {
        show: false,
        title: '',
        message: '',
        color: ''
      },
      baseUrl: '',
      activeTabIndex: 0,
      redirect: true
    }
  },

  async created() {
    await this.getSections()
    await this.setItem()
    await this.getProductsOptions()
  },

  methods: {
    async setItem() {
      if (this.$route.params.id) {
        const data = await Service.show(this.$route.params.id)

        if (data) {
          this.item = {
            id: this.$route.params.id,
            section_id: data.section_id,
            section_slug: data.section_slug,
            section_slug_en: data.section_slug_en,
            section_slug_es: data.section_slug_es,
            title: data.title,
            title_en: data.title_en,
            title_es: data.title_es,
            views: data.views,
            slug: data.slug,
            slug_en: data.slug_en,
            slug_es: data.slug_es,
            description: data.description,
            description_en: data.description_en,
            description_es: data.description_es,
            status: !!data.status,
            status_en: !!data.status_en,
            status_es: !!data.status_es,
            related: data.related.map(product => product.id),
            related_en: data.related_en.map(product => product.id),
            related_es: data.related_es.map(product => product.id),
            seo: {
              seo_title: data.seo.title,
              seo_description: data.seo.description
            },
            seo_en: {
              seo_title: data.seo_en.title,
              seo_description: data.seo_en.description
            },
            seo_es: {
              seo_title: data.seo_es.title,
              seo_description: data.seo_es.description
            }
          }

          this.setSectionSlug()

          this.log = {
            created_by: data.created ? data.created.name : 'Seed',
            created_at: moment(data.created_at).format('DD/MM/YYYY HH:mm'),
            updated_by: data.updated ? data.updated.name : null,
            updated_at: moment(data.updated_at).format('DD/MM/YYYY HH:mm')
          }
        }
      }

      this.form = cloneDeep(this.item)
    },

    async getSections() {
      const response = await ChapterService.index({ pagination: false, sorter: { column: 'title', asc: true } })

      const options = response.data.map(item => {
        return {
          value: item.id,
          label: item.title,
          slug: item.slug,
          slug_en: item.slug_en,
          slug_es: item.slug_es
        }
      })

      this.sectionsOptions = [...this.sectionsOptions, ...options]
    },

    async getProductsOptions() {
      const response = await ProductService.index({ pagination: false, sorter: { column: 'title', asc: true } })

      this.productsOptions = response.data.map(item => {
        return {
          value: item.id,
          label: item.title
        }
      })

      this.productsOptionsEn = response.data.filter(item => {
        if (item.status_en === 1) {
          return true
        }
      }).map(item => {
        return {
          value: item.id,
          label: item.title_en
        }
      })

      this.productsOptionsEs = response.data.filter(item => {
        if (item.status_es === 1) {
          return true
        }
      }).map(item => {
        return {
          value: item.id,
          label: item.title_es
        }
      })
    },

    resetForm() {
      this.setItem()
    },

    setRedirect(event) {
      this.redirect = !event
    },

    handleActiveTab(index) {
      this.activeTabIndex = index
    },

    setSectionSlug() {
      const value = this.sectionsOptions.find(option => option.value === this.form.section_id)

      if (this.form.status) {
        this.form.section_slug = value.slug
      }

      if (this.form.status_en) {
        this.form.section_slug_en = value.slug_en
      }

      if (this.form.status_es) {
        this.form.section_slug_es = value.slug_es
      }
    },

    async send() {
      this.processing = true

      let response
      let message

      this.setSectionSlug()

      const data = {
        id: this.$route.params.id,
        section_id: this.form.section_id,
        section_slug: this.form.section_slug,
        section_slug_en: this.form.section_slug_en,
        section_slug_es: this.form.section_slug_es,
        title: this.form.title,
        title_en: this.form.title_en,
        title_es: this.form.title_es,
        views: this.form.views,
        slug: this.form.slug,
        slug_en: this.form.slug_en,
        slug_es: this.form.slug_es,
        description: this.form.description,
        description_en: this.form.description_en,
        description_es: this.form.description_es,
        status: this.form.status,
        status_en: this.form.status_en,
        status_es: this.form.status_es,
        related: this.form.related,
        related_en: this.form.related_en,
        related_es: this.form.related_es,
        seo_title: this.form.seo.seo_title,
        seo_description: this.form.seo.seo_description,
        seo_title_en: this.form.seo_en.seo_title,
        seo_description_en: this.form.seo_en.seo_description,
        seo_title_es: this.form.seo_es.seo_title,
        seo_description_es: this.form.seo_es.seo_description
      }

      if (this.$route.params.id) {
        response = await Service.update(this.$route.params.id, data)
        message = 'Publicação foi atualizada com sucesso!'
      } else {
        response = await Service.store(data)
        message = 'Publicação foi cadastrada com sucesso!'
      }

      this.processing = false

      if (response.status === 200) {
        this.modal = {
          show: true,
          title: 'Sucesso',
          message: message,
          color: 'success',
          redirect: this.redirect
        }

        if (this.redirect) {
          this.resetForm()
          setTimeout(() => {
            this.$router.push(
              this.$route.matched[this.$route.matched.length - 2].path
            )
          }, 3000)
        } else {
          this.resetForm()
          setTimeout(() => {
            this.processing = false
            document.getElementById('first').focus()
            this.modal.show = false
          }, 1000)
        }
      } else if (response.status === 400) {
        this.modal = {
          show: true,
          title: 'Erro',
          message: response.data.messages[0].message || response.data,
          color: 'danger'
        }
      } else {
        this.modal = {
          show: true,
          title: 'Erro',
          message: 'Ocorreu um erro interno, por favor tente novamente!',
          color: 'danger'
        }
      }
    }
  }
}
</script>
